import React from "react"
import {Table} from "@mui/material";
import StudyBar from "../../../components/StudyBar";
import CustomizedTables from "../../../components/FrameworkTable";

function WhyJavascript(){

    return (

        <div className="JavaScriptFunctions " style={{  textAlign:"center"}}>
            <br></br>

            <StudyBar/>
            <br/><br/>
            <div style={{fontSize:"2em",fontFamily:"Segoe UI", fontWeight:"700",textAlign:"left", margin:"40px"}}>Why Javascript

            </div>


            <div className="WhyJavascript " style={{margin:"15px",textAlign:"left", with:"100%", wordSpace:"1.5px",padding:"15px", }}>

                <h3 >1. Deep Dive Into Javascript</h3><br></br><br></br>

                <p>
                    In the world of web app development javascript is the most import programming language to make your application dynamic, interactive and reliable.There are many
                    reasons to that, I will like to quickly touch on these reason. Here is the answers to the <strong> WHY ? </strong>
                </p>
                <br></br>
                <p>
                    Most modern Frontend and Backend Frameworks are built with Javascript Programming Language, this mean you can become a Fullstack Developer by simply mastering <strong>Javascript
                    Programming</strong>. Today, there is a great demand for Frontend developers who knows how to develop Frontend Application with<strong> React Framework.</strong> Again, one question
                    that comes to mind is what exactly is this <strong> React Framework ?.</strong>
                </p>
                <br></br>
                <p>
                    Is simply Javascript Libraries for building Frontend Applications, is also very important to know
                    what these Libraries are ! Think of it as collections of classes and methods ( Javascript In-built Function ) for building Frontend Application. As we all know
                    any website my have these following:
                    <ul style={{margin:"15px"}}>

                        <li>Buttons</li>
                        <li>Navigations</li>
                        <li>Slide Presentations</li>
                        <li>Valid Contact Form</li>
                        <li>Pop-up Messages</li>
                        <li>Chat Box</li>
                        <li>Responsiveness( Autoscaling ability to any device size)</li>
                        <li>Http Request Functionality</li>
                        <li>Edit Functionality</li>
                        <li>Update Functionality</li>
                        <li>Delete Functionality</li>

                    </ul>
                </p>
                <br></br>
                <p>
                    All of these above functionalities were made possible by these Javascript libraries, no matter your background
                    and area of expertise, to be a successful Frontend Developer not just a website developer you need to know about
                    Javascript.
                </p>
                <br></br>
                <h3 >2. Frameworks Developed With Javascript</h3><br></br><br></br>
                It is very interesting to know that these following frameworks were actually developed with Javascript, that was why
                I said, no matter your background you need to know about Javascript.
                <br/><br/>

                <div className=" container ">
                    <CustomizedTables/>
                </div>

            </div>
        </div>
    )

}
export default WhyJavascript;
